import { createContext, useContext } from "react"
import type { TabsBaseOrientation } from "../tabs-base"

// =============================================================================
// Context
// =============================================================================

export type TabLinksContextValue = {
  currentPath: string
  orientation: TabsBaseOrientation
}

export const TabLinksContext = createContext<TabLinksContextValue | null>(null)

export function useTabLinksContext(): TabLinksContextValue {
  const context = useContext(TabLinksContext)
  if (!context) throw new Error("TabLinks.Item must be used within a TabLinks")
  return context
}
